export default "__VITE_ASSET__v1GlokWa__"